import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "RegisterTeacher" })
export default class RegisterTeacher extends Vue {
    public isLoading: boolean = false;
    public validationErrors: any[] = [];
    public productCategories: any[] = [];
    public subjectScopes: any[] = [];
    public productCodes: any[] = [];
    public provinces: any[] = [];
    public locations: any[] = [];
    public registerTeacherSubmit: any = { productCategoryName: null, subjectScopeCode: null, productCode: null, instituteProvince: null, instituteLocation: null };

    @Prop() readonly recaptchaSiteKey: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.getProductCategories();
        this.getProvinces();
    }

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.recaptcha.net/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async getProductCategories() {
        let response = await this.$store.dispatch("catalogueStore/getProductCategories");

        if (response) {
            this.productCategories = response.data;
        }
    }

    public async getSubjectScopes() {
        let response = (await Axios.post(this.routes.Subject_GetSubjectScopes, { ProductCategoryName: this.registerTeacherSubmit.productCategoryName })).data;

        if (response) {
            this.subjectScopes = response;
            this.registerTeacherSubmit.subjectScopeCode = null;
            this.registerTeacherSubmit.productCode = null;
        }
    }

    public async getProductCodes() {
        let response = await this.$store.dispatch("catalogueStore/getProductCodes", {
            subjectScopeCode: this.registerTeacherSubmit.subjectScopeCode,
            productCategoryName: this.registerTeacherSubmit.productCategoryName
        });

        if (response) {
            this.productCodes = response.data;
            this.registerTeacherSubmit.productCode = null;
        }
    }

    public async getProvinces() {
        let response = await this.$store.dispatch("salesNetStore/getProvinces");
        if (response) {
            this.provinces = response.data;
        }
    }

    public async getLocations() {
        if (this.registerTeacherSubmit.instituteProvince) {
            let response = await this.$store.dispatch("salesNetStore/getLocations", {
                provinceCode: this.registerTeacherSubmit.instituteProvince
            });

            if (response.data) {
                this.locations = response.data;

                if (this.locations && this.locations.length === 1) {
                    this.registerTeacherSubmit.instituteLocation = this.locations[0].value;
                } else {
                    this.registerTeacherSubmit.instituteLocation = null;
                }
            }
        } else {
            this.locations = null;
        }
    }

    public async setRegisterTeacherSubmit() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.AccountTeacher_Register, this.registerTeacherSubmit, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } })).data;

            (<any>window).location = result;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};